export const exampleRecipe = {
  id: "name",
  link: "/#/recipes/recipes/name",
  name: "Name",
  cuisine: "Rosharan",
  summary: "Visible summary",
  inspiration: null,
  quantity: "5",
  time: "1 hour",
  notes: "Hidden notes",
  quotes: "Italic book quotes",
  image: "https://example.com",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "ingredientId",
          display: "1/2 cup nothing"
        }
      ]
    }
  ],
  steps: ["text"]
}
